import { Button, Grid, Input, InputLabel } from '@mui/material';

import React, { useState } from 'react';

import TabContext from '@mui/lab/TabContext';

import TabList from '@mui/lab/TabList';

import Tab from '@mui/material/Tab';

import Typography from '@mui/material/Typography';

import Box from '@mui/material/Box';

import TabPanel from '@mui/lab/TabPanel';

import Users from './Users';

import MessagesSetting from './MessagesSetting';

import Modal from '@mui/material/Modal';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	p: 4,
	borderRadius: '10px',
};

function Messages() {
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	// const handleClose = () => setOpen(false);

	const [value, setValue] = React.useState('1');

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Grid container>
			<Grid item xs={12} lg={12} xl={12}>
				<TabContext value={value}>
					<Box sx={{ borderColor: 'divider' }}>
						<TabList onChange={handleChange}>
							<Tab
								style={{
									fontSize: '16px',
									fontWeight: '500',
									fontFamily: 'Poppins',
									paddingBottom: '0px',
									paddingTop: '0px',
									textTransform: 'capitalize',
								}}
								label="messages setting"
								value="1"
							/>
							<Tab
								style={{
									fontSize: '18px',
									fontWeight: '500',
									fontFamily: 'Poppins',
									paddingBottom: '0px',
									paddingTop: '0px',
									textTransform: 'capitalize',
								}}
								label="users"
								value="2"
							/>
						</TabList>
						{/* Conditionally render the button */}
						{value === '2' && (
							<Button
								onClick={handleOpen}
								variant="contained"
								sx={{
									position: 'absolute',
									top: '13%',
									right: '2%',
									background: '#FD7702',
									fontWeight: '500',
									fontFamily: 'Poppins',
									'&:hover': {
										border: '#FD7702',
										color: '#FD7702',
										background: 'white',
									},
									'@media (max-width: 900px)': {
										// Styles for xs and sm screens
										top: '75%',
										right: '5%',
									},
									'@media (max-width: 600px)': {
										// Styles for xs and sm screens
										position: 'relative',
										left: '5%',
									},
									'@media only screen and (max-width: 1920px) and (min-width: 1760px)':
										{
											// Styles for xs and sm screens
											top: '10%',
										},
								}}
							>
								Add User
							</Button>
						)}
						<Modal
							open={open}
							onClose={handleClose}
							aria-labelledby="modal-modal-title"
							aria-describedby="modal-modal-description"
						>
							<Box sx={style}>
								<Grid container lg={12} xs={12} md={12} sm={12}>
									<Grid
										item
										lg={12}
										xs={12}
										md={12}
										sm={12}
										xl={12}
										justifyContent="center"
									>
										<Typography
											variant="h5"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '32px',
												fontWeight: '500',
												textAlign: 'center',
											}}
										>
											Add User
										</Typography>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Name
										</InputLabel>
										<Input
											name="userName"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Mobile
										</InputLabel>
										<Input
											name="mobile"
											type="number"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Email
										</InputLabel>
										<Input
											name="email"
											type="email"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Role
										</InputLabel>
										<Input
											name="role"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={12}
										xs={12}
										md={12}
										sm={12}
										xl={12}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Address
										</InputLabel>
										<Input
											name="address"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={4}
										xs={4}
										md={4}
										sm={4}
										xl={4}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											City
										</InputLabel>
										<Input
											name="city"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={4}
										xs={4}
										md={4}
										sm={4}
										xl={4}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											State
										</InputLabel>
										<Input
											name="state"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={4}
										xs={4}
										md={4}
										sm={4}
										xl={4}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											ZIP
										</InputLabel>
										<Input
											name="zip"
											type="text"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										container
										lg={12}
										xs={12}
										md={12}
										sm={12}
										xl={12}
										justifyContent="center"
										sx={{ marginTop: '10px' }}
									>
										<Grid item lg={4} xs={4} md={4} sm={4} xl={4}>
											<Button
												onClick={handleClose}
												fullWidth
												sx={{
													background: '#ED2828',
													border: '2px solid #ED2828',
													color: 'white',
													marginRight: '5px',
													fontFamily: 'Poppins',
													fontSize: '16px',
													fontWeight: '400',
													'&:hover': {
														color: '#ED2828',
														background: 'white',
														border: '2px solid #ED2828',
													},
												}}
											>
												Cancel
											</Button>
										</Grid>
										<Grid item lg={4} xs={4} md={4} sm={4} xl={4}>
											<Button
												fullWidth
												sx={{
													background: '#FD7702',
													border: '2px solid #FD7702',
													color: 'white',
													marginLeft: '5px',
													fontFamily: 'Poppins',
													fontSize: '16px',
													fontWeight: '400',
													'&:hover': {
														color: '#FD7702',
														background: 'white',
														border: '2px solid #FD7702',
													},
												}}
											>
												ADD
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Box>
						</Modal>
					</Box>
					<TabPanel value="1" sx={{ padding: '0px' }}>
						<MessagesSetting />
					</TabPanel>
					<TabPanel value="2" sx={{ padding: '0px' }}>
						<Users />
					</TabPanel>
				</TabContext>
			</Grid>
		</Grid>
	);
}

export default Messages;
